import React, { memo, useCallback, useEffect } from "react";
import { Card, Input, Controller, Button, SelectBox } from "components/src";
import { useTranslation } from "react-i18next";
import { FormProvider, useForm } from "react-hook-form";
import { Form, message } from "antd";
import {
  useGetAdminGetAllGroupsList,
  useGetAdminUsersList,
  useGetUserFindUser,
  usePutAdminUpdateChannelAndGroup,
} from "core";
import { useParams } from "react-router-dom";
import LoadingView from "../../atoms/loadingView";

const CONVERSATIONTITLE = "conversationTitle";
const ADDS = "adds";
const REMOVES = "removes";
const ADD_ADMINS = "addAdmins";
const REMOVE_ADMINS = "removeAdmins";

const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 16 },
};

const EditGroup = memo(() => {
  const { i18n } = useTranslation();
  const { id } = useParams();
  const [messageApi, contextHolder] = message.useMessage();

  const { data: { data: allUserData } = {} ,refetch} = useGetAdminUsersList({
    pageNumber: "1",
    pageSize: "2000",
  });


  const { data: groupData, isFetching: groupListFetch,refetch:_refetch } =
    useGetAdminGetAllGroupsList({
      pageNumber: "1",
      pageSize: "2000",
      groupId: id,
    });

  const methods = useForm({
    defaultValues: {
      conversationTitle: "",
      adds: [],
      removes: [],
      addAdmins: [],
      removeAdmins: [],
    },
  });

  const { handleSubmit, reset, setValue } = methods;
  useEffect(() => {
    if (groupData) {
      setValue("conversationTitle", groupData?.data?.conversations?.[0]?.title);
    }
  }, [groupData, setValue]);



  const onSubmit = useCallback(
    ({
      conversationTitle,
      adds,
      removes,
      addAdmins,
      removeAdmins,
    }: {
      conversationTitle: any;
      adds: any[];
      removes: any[];
      addAdmins: any[];
      removeAdmins: any[];
    }) => {
      mutate({
        requestBody: {
          conversationId: id || "",
          conversationTitle: conversationTitle,
          ...(adds?.length && { adds: adds }),
          ...(removes?.length && { removes: removes }),
          ...(addAdmins?.length && { addAdmins: addAdmins }),
          ...(removeAdmins?.length && { removeAdmins: removeAdmins }),
        },
      });
    },
    []
  );

  const { mutate, isPending } = usePutAdminUpdateChannelAndGroup({
    onSuccess: () => {
      reset();
      messageApi.open({
        type: "success",
        content: i18n.t("done"),
      });
      refetch()
      _refetch()
    },
  });

  const groupParticipants=groupData?.data?.conversations?.[0]?.participants.map((item:any)=>{return item.user})
  const groupAdmins=groupData?.data?.conversations?.[0]?.admins?.map((item:any)=>{return item})

  let userNamesToRemoveFromAllUserData = new Set(groupParticipants?.map((user:any) =>{return user.user_name}));
  let userNamesToRemoveFromAllGroupParticipants=new Set(groupAdmins?.map((user:any) =>{return user.user_name}))
  
  let filteredAllUserData = allUserData?.users.filter((user:any) => {return !userNamesToRemoveFromAllUserData.has(user?.userName)});
  let filteredAllAdmins=groupParticipants?.filter((user:any)=>{return !userNamesToRemoveFromAllGroupParticipants.has(user.user_Name)})
  const addItems=filteredAllUserData?.map((item:any)=>{
     return {
      value:item.userName,
      label:item.nameAndFamily
     }
  })
  const removeItems=groupParticipants?.map((item:any)=>{
    return{
      value:item.user_name,
      label:item.name_and_family
    } })


  const addAdminsItem=filteredAllAdmins?.map((item:any)=>{
     return {
      value:item.user_name,
      label:item.name_and_family
     }
  })

  const removeAdminsItem=groupAdmins?.map((item:any)=>{
    return {
     value:item.user_name,
     label:item.name_and_family
    }
 })

    


  return (
    <>
      {contextHolder}

      <LoadingView isLoading={groupListFetch}>
        <Card title={i18n.t("EditGroup")}>
          <FormProvider {...methods}>
            <Form
              {...layout}
              name="nest-messages"
              onFinish={handleSubmit(onSubmit)}
            >
              <Form.Item>
                <Controller name={CONVERSATIONTITLE}>
                  <Input placeholder={i18n.t("name")} />
                </Controller>
              </Form.Item>

              <Form.Item>
                <Controller name={ADDS}>
                  <SelectBox
                    mode="tags"
                    aria-multiselectable
                    label={i18n.t("addItems")}
                    options={addItems}
                    placeholder={i18n.t("role")}
                  />
                </Controller>
              </Form.Item>

              <Form.Item>
                <Controller name={REMOVES}>
                  <SelectBox
                    mode="tags"
                    aria-multiselectable
                    label={i18n.t("removeItems")}
                    options={removeItems}
                    placeholder={i18n.t("role")}
                  />
                </Controller>
              </Form.Item>

              <Form.Item>
                <Controller name={ADD_ADMINS}>
                  <SelectBox
                    mode="tags"
                    aria-multiselectable
                    label={i18n.t("addAdminsItem")}
                    options={addAdminsItem}
                    placeholder={i18n.t("role")}
                  />
                </Controller>
              </Form.Item>

              <Form.Item>
                <Controller name={REMOVE_ADMINS}>
                  <SelectBox
                    mode="tags"
                    aria-multiselectable
                    label={i18n.t("removeAdminsItem")}
                    options={removeAdminsItem}
                    placeholder={i18n.t("role")}
                  />
                </Controller>
              </Form.Item>

              <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 5 }}>
                <Button
                  style={{ width: "100px" }}
                  type="primary"
                  isLoading={isPending}
                  htmlType="submit"
                >
                  {i18n.t("update")}
                </Button>
              </Form.Item>
            </Form>
          </FormProvider>
        </Card>
      </LoadingView>
    </>
  );
});
export { EditGroup };
